import React from 'react';
import { useDispatch } from 'react-redux';

const useLoading = () => {
  const dispatch = useDispatch();

  const loading = React.useMemo(
    () => ({
      set: () => dispatch({ type: 'SHOW_LOADER', payload: true }),
      stop: () => dispatch({ type: 'SHOW_LOADER', payload: false }),
    }),
    [dispatch],
  );

  return loading;
};

export default useLoading;
